/**
 * One-testimonial-at-a-time slider (Testimonials Slider section).
 * Kept separate from jb-owl-carousel.js: it always shows a single, full-width
 * item with dots, while the generic initializer works with per-row item
 * counts and clamps single-item carousels to a fixed width.
 */
function initializeTestimonialsSliders() {
  $(".jb-testimonials-slider-container").each(function() {
    const containerElement = $(this);
    const owlCarouselElement = $('.owl-carousel', containerElement);
    const sectionId = owlCarouselElement.data('section-id');

    if (!sectionId) {
      return;
    }

    const owlCarousel = $(".owl-carousel-" + sectionId, containerElement);

    if (owlCarousel.length === 0) {
      return;
    }

    const itemsCount = $('.jb-testimonials-slider-item-container', owlCarousel).removeClass('d-none').length;

    // The dots live in their own container so the builder's "Slider Dots"
    // style group (color/size classes on that element) can style them.
    const dotsContainer = $('.jb-tsl-dots-' + sectionId, containerElement);

    owlCarousel.owlCarousel({
      loop: itemsCount > 1,
      items: 1,
      margin: 0,
      nav: false,
      dots: itemsCount > 1,
      dotsContainer: dotsContainer.length ? dotsContainer : false,
      autoHeight: true,
    });
  });
}

function onTestimonialsSliderInitOrRender() {
  initializeTestimonialsSliders();
}

document.addEventListener('DOMContentLoaded', onTestimonialsSliderInitOrRender);
document.addEventListener('jb.section.rendered', onTestimonialsSliderInitOrRender);
document.addEventListener('section.initiated', onTestimonialsSliderInitOrRender);
